export default {
    description: 'Hier können Spalten ein- und ausgeblendet werden',

    showAll: 'Alle einblenden',
}